import {
  RouterProvider,
  Navigate,
  createHashRouter,
} from "react-router-dom";
import Signup from "./pages/Signup";
import SearchPage from "./pages/SearchPage";
import FavoritesPage from "./pages/FavoritesPage";
import AccountSettingsPage from "./pages/AccountSettingsPage";
import SelfProfilePage from "./pages/SelfProfilePage";
import ProtectedRoute from "./pages/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import ProfileEditPage from "./pages/ProfileEditPage";
import ProfilePage from "./pages/ProfilePage";
import DynamicHeader from "./components/header/DynamicHeader";
import Footer from "./components/Footer";
import TrialBanner from "./components/TrialBanner";
import { SignedIn } from "./components/auth/SignedIn";
import MessagesPage from "./pages/MessagesPage";
import ReferralProgram from "./pages/ReferralProgram";
import { ErrorPage } from "./components/ErrorPage";
import { AuthBootstrapper } from "./components/auth/AuthBootstrapper";
import InstallInstructionsPage from "./pages/InstallInstructionsPage";
import UpgradePageSelector from "./pages/UpgradePageSelector";
import MobileOverlayOutlet from "./components/layout/MobileOverlayOutlet";

function Layout() {
  return (
    <div className="flex flex-col min-h-[100dvh] bg-black text-white pt-safe-top">
      <SignedIn fallback={null}>
        <TrialBanner />
      </SignedIn>
      <DynamicHeader />
      <main className="flex flex-grow w-full py-4 px-2 sm:px-6 lg:px-8 bg-black">
        <MobileOverlayOutlet />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  const router = createHashRouter([
    {
      path: "/",
      element: <Layout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/",
          element: (
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          ),
        },
        {
          path: "search",
          element: (
            <ProtectedRoute>
              <SearchPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "favorites",
          element: (
            <ProtectedRoute>
              <FavoritesPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "messages",
          children: [
            {
              path: "",
              element: (
                <ProtectedRoute>
                  <MessagesPage />
                </ProtectedRoute>
              ),
            },
            {
              path: ":profileId",
              element: (
                <ProtectedRoute>
                  <MessagesPage />
                </ProtectedRoute>
              ),
            },
          ],
        },
        {
          path: "profile",
          element: (
            <ProtectedRoute>
              <SelfProfilePage />
            </ProtectedRoute>
          ),
        },
        {
          path: "profile/edit",
          element: (
            <ProtectedRoute>
              <ProfileEditPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "profile/:userId",
          element: (
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          ),
        },
        {
          path: "settings",
          element: (
            <ProtectedRoute>
              <AccountSettingsPage />
            </ProtectedRoute>
          ),
        },
        {
          path: "upgrade",
          element: (
            <ProtectedRoute>
              <UpgradePageSelector />
            </ProtectedRoute>
          ),
        },
        {
          path: "install",
          element: <InstallInstructionsPage />,
        },
        {
          path: "/sign-up",
          element: <Signup />,
        },
        {
          path: "/refer",
          element: (
            <ProtectedRoute>
              <ReferralProgram />
            </ProtectedRoute>
          ),
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ]);

  return (
    <AuthBootstrapper>
      <RouterProvider router={router} />
    </AuthBootstrapper>
  );
}

export default App;
